<template>
    <div class="dropdown" v-if="workPlaces.length>0">
        <b-button-group>
            <button class="btn btn-white" :class="{ [customXStyle]: customXStyle }" @click="clear" v-if="localValue.length>0">
                <span class="fe fe-x"></span>
            </button>
            <b-dropdown
                :variant="getButtonVariant"
                no-flip
                :text="$t('Workplace')"
                :no-caret="isIconView"
                class="btn-link-reset"
                v-b-tooltip="{disabled: !isIconView }"
                :title="[ isIconView ? $t('Workplace') : '' ]"
            >
                <template #button-content v-if="isIconView">
                    <span class="fe fe-briefcase"></span>
                </template>
                <div
                    v-for="(workPlace, index) in workPlaces"
                    :key="index"
                    :style="memberStyles(workPlace.color)"
                    class="dropdown-item pl-3"
                >
                    <b-form-checkbox v-model="localValue" :value="workPlace._id">{{ workPlace.label }}</b-form-checkbox>
                </div>
            </b-dropdown>
        </b-button-group>
    </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import Avatar from '@/components/Avatar.vue'

export default {
    props: ['value', 'params', 'isIconView', 'customXStyle'],
    components: {
        Avatar
    },
    data() {
        return {}
    },
    computed: {
        ...mapState('work-place', { isTeamLoading: 'isFindPending' }),
        ...mapGetters('work-place', { findWorkPlacesInStore: 'find' }),
        workPlaces() {
            return this.findWorkPlacesInStore(this.params).data;
        },

        localValue: {
            get() {
                return this.value
            },
            set(newVal) {
                this.$emit('input', newVal);
                this.$emit('change', newVal);

            }
        },
        getButtonVariant() {
            return this.isIconView ? "link" : "white";
        }

    },
    methods: {
        clear() {
            this.localValue = [];
        },
        memberStyles(color) {
            return 'border-right:3px solid ' + color;
        },
    }

}
</script>
<style lang="scss">
    .btn-link-reset {
        .btn-link {
            color: inherit!important;
        }
    }
</style>

<style lang="scss" scoped>
.no-border {
    border-radius: 0;
    border: none;
    border-right: 2px solid #e4ebf7;
}
</style>
